<template>
  <button @click="$emit('fixed-button:click')" v-if="canShow">
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    /* eslint-disable-next-line */
    show: Boolean
  },
  computed: {
    canShow() {
      if (this.show !== undefined) return this.show;
      return (
        this.$root.screen.lg ||
        this.$root.screen.md ||
        this.$root.screen.sm ||
        this.$root.screen.xs
      );
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  position: fixed;
  right: 10px;
  bottom: 10px;
  background: $primary;
  color: $white;
  width: 50px;
  height: 50px;
  border-radius: 100%;
  border: none;
  z-index: 2222;

  &:hover {
    background: $primary-hover;
  }

  &:focus,
  &:active {
    background: $primary-active;
    outline: none;
  }
}
</style>
